import React from "react";
import clsx from "clsx";

import Button from "@material-ui/core/Button";

import useStyles from "./styles";

interface IProps {
  canSubmit: boolean;
  onOpenReviewForm: () => void;
  onSaveAndClose: () => void;
}

const StallApplicationFooter = (props: IProps) => {
  const { canSubmit, onOpenReviewForm, onSaveAndClose } = props;
  const classes = useStyles();

  return (
    <div className={classes.root}>
      <Button
        className={clsx(classes.button, classes.saveAndCloseButton)}
        variant={"outlined"}
        onClick={onSaveAndClose}
      >
        Save & Close
      </Button>
      <Button
        className={clsx(classes.button, classes.reviewFormButton)}
        variant={"contained"}
        disabled={!canSubmit}
        onClick={onOpenReviewForm}
      >
        Review Form
      </Button>
    </div>
  );
};

export default React.memo(StallApplicationFooter);
